module.exports = "https://www.gc-pro.gnp.com.mx/3fbbdb83c5df87a6d041edd70e202541.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-formato.svg
// module id = 1827
// module chunks = 0